import apiRequest from '@/http/api-request';
import authService from '@/auth/authService';

const moment = require('moment');

export default {
  nextAddADonationStep(
    { commit, state },
    { addADonationDetails = {}, saveCurrent = true },
  ) {
    const currentAddADonation = state.addADonation;

    const nextAddADonation = {
      ...currentAddADonation,
      ...addADonationDetails,
      ...(saveCurrent ? { previousState: { ...currentAddADonation } } : {}),
    };

    commit('SET_ADD_A_DONATION', nextAddADonation);
  },

  previousAddADonationStep({ commit, state }) {
    const currentAddADonation = state.addADonation;

    // Its on the first step
    if (!currentAddADonation.previousState) {
      return;
    }

    commit('SET_ADD_A_DONATION', currentAddADonation.previousState);
  },

  resetAddADonationStep({ commit }) {
    commit('RESET_ADD_A_DONATION');
  },

  fetchAllDonations({ commit, state }, { charityId, force = false }) {
    if (state.donationsState === 'loading') {
      return new Promise((resolve) => resolve(state.donations));
    }

    if (
      state.donationsState === 'ready' &&
      force !== true &&
      parseInt(new Date().getTime() / 1000) - state.lastUpdate < 60 * 15 //15 min cache
    ) {
      return new Promise((resolve) => resolve(state.donations));
    }

    commit('LOADING_DONATIONS');

    return new Promise((resolve, reject) => {
      return apiRequest
        .doGetRequest(
          '/data/donations',
          {
            charity_id: charityId,
            start_date: '01/01/2016',
            end_date: moment().format('MM/DD/YYYY'),
          },
          { 'X-Harness-JWT': authService.getToken() },
          {
            skipCache: true,
            resCallback: (donations) => {
              // Pre-parse the created_at timestamp so we don't need to re-parse it multiple times later.
              for (let donation of donations) {
                donation.createdAtParsed = moment(
                  donation.created_at,
                  'YYYY/MM/DD HH:mm:ss',
                ).unix();
              }

              return donations;
            },
          },
        )
        .then((donations) => {
          commit('SET_DONATIONS', donations);
          resolve(donations);
        })
        .catch((error) => reject(error));
    });
  },
};
